// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1iA-2","colMaxWidth":"Table_colMaxWidth__2f2ZD"};